import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import CustomDataGrid from "../../Components/CustomDataGrid";
import { REACT_APP_BACKEND_URL } from "../../Utils/Language/urlBase";
import { toast } from "react-toastify";
import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";

const ItemsBelowMinQuantity = () => {
    const [items, setItems] = useState([]);
    const authHeader = useAuthHeader(); // Added authentication header

    const fetchItems = async () => {
        try {
            const response = await fetch(
                `${REACT_APP_BACKEND_URL}/items/below-min-quantity`,
                {
                    method: "GET",
                    headers: {
                        Authorization: authHeader, // Added Authorization header
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response.ok) {
                const responseData = await response.json();
                setItems(responseData.items);
            } else {
                throw new Error(
                    "Failed to fetch items below minimum quantity."
                );
            }
        } catch (error) {
            toast.error(error.message || "Error fetching items.");
        }
    };

    useEffect(() => {
        fetchItems();
    }, [authHeader]);

    const columns = [
        { field: "name", headerName: "Name", width: 200 },
        { field: "barcode", headerName: "Barcode", width: 150 },
        { field: "description", headerName: "Description", width: 250 },
        { field: "minAlarmQuantity", headerName: "Min Quantity", width: 150 },
        {
            field: "quantityRemaining",
            headerName: "Quantity Remaining",
            width: 150,
        },
    ];

    return (
        <Box sx={{ width: "100%" }}>
            <Typography
                variant="h4"
                sx={{ fontWeight: "bold", mb: 2 }}
                color="primary"
            >
                Items Below Minimum Quantity
            </Typography>
            <CustomDataGrid columns={columns} rows={items} perPage={20} />
        </Box>
    );
};

export default ItemsBelowMinQuantity;
